module.exports = __webpack_public_path__ + "static/media/desktop-icon.c30dc6a9.png";